import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import CopyIcon from '@material-ui/icons/FilterNone';

import ConfirmDeleteButton from '../../../Common/Buttons/ConfirmDeleteButton';
import isPresent from '../../../Common/Utils/Present';
import StatusIconMedium from '../../../Common/Icons/StatusMedium';

type Props = {
  adUnitFormValues: any,
  expandIcon: any,
  fields: any,
  handleRemove: any,
  handleTouchTap: any,
  index: number,
  record: any
};

class AdUnitHead extends Component<Props> {
  handleCopyClick = (event) => {
    event.stopPropagation();
    let copyAdUnit = { ...this.props.adUnitFormValues[this.props.index] };
    copyAdUnit.div_id = copyAdUnit.div_id + ` - copy`;

    this.props.fields.push(copyAdUnit);
  }

  render() {
    let active = true;
    let divId;
    let position;
    let atf;
    let sizes;

    if (isPresent(this.props.record.ad_units && this.props.record.ad_units[this.props.index])) {
      let adUnit = this.props.record.ad_units[this.props.index]

      active = !adUnit.inactive;

      if (adUnit.div_id) {
        divId = <span style={{ paddingLeft: 10 }}>{adUnit.div_id}</span>;
      }

      if (adUnit.position) {
        position = <span style={{ paddingLeft: 10 }}>P:{adUnit.position}</span>;
      }

      atf = <span style={{ paddingLeft: 10 }}>{adUnit.atf ? 'ATF' : 'BTF'}</span>;

      if (isPresent(adUnit.sizes)) {
        sizes = <span style={{ paddingLeft: 10 }}>{adUnit.sizes.join(', ')}</span>;
      }
    } else {
      divId = <span style={{ paddingLeft: 10 }}>New Ad Unit</span>;
    }

    return (
      <div>
        <div onClick={() => this.props.handleTouchTap(this.props.index)} style={{ cursor: 'pointer', backgroundColor: '#f5f5f5', padding: 15 }}>
          <StatusIconMedium enabled={active} style={{ paddingTop: 10 }} />
          {divId}
          {position}
          {atf}
          {sizes}
          <span style={{ paddingLeft: 10 }}>{this.props.expandIcon}</span>

          <div style={{ float: 'right' }}>
            <Button variant="text" title="Copy" onClick={this.handleCopyClick}><CopyIcon /></Button>
            <ConfirmDeleteButton onClick={(event) => this.props.handleRemove(event, this.props.index)} />
          </div>
        </div>
      </div>
    )
  }
};

const mapStateToProps = (state, props) => (
  { adUnitFormValues: state.form['record-form'].values.ad_units }
);

export default connect(mapStateToProps, {})(AdUnitHead);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/AdUnitHead.tsx